import React, { useState } from 'react'
import {
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  notification,
  Popconfirm,
  Row,
  Select,
  Table,
  Tabs,
  Tag
} from 'antd'
import { useDeepEffect } from '../../../../utils/hooks'
import { CoinType } from '../../../../config'
import { isEmpty } from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import CoinForm from './components/UpdateCoinForm'
import { fetchCoinByHeroId, fetchTransectionByHeroId, updateCoin } from '../../../../modules/coin'
import moment from 'moment';
import Lightbox from "react-image-lightbox";
import "../../../../../node_modules/react-image-lightbox/style.css";

export const HeroCoin = ({ data }) => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [current, setCurrent] = useState('')
  const [formData, setFormData] = useState({})
  const { coin, transaction, isLoading } = useSelector(
    (state) => ({
      coin: state.coin.coin.currentCoin,
      transaction: state.coin.transaction,
      isLoading: state.coin.isLoading
    }),
    []
  )
  const heroId = data.id

  function fetch() {
    dispatch(fetchCoinByHeroId(data.id))
    dispatch(fetchTransectionByHeroId(data.id))
  }

  const onClick = () => {
    setVisible(true)
  }

  const onCloseModal = async () => {
    await fetch()
    await setVisible(false)
  }

  const onOk = async (data) => {
    await dispatch(updateCoin(data))
    await fetch()
    await setVisible(false)
    await setFormData({})
  }
  useDeepEffect(() => {
    if (!isEmpty(data)) {
      fetch()
    }
  }, [data])

  const columns = [
    {
      title: 'Credit/Debit',
      dataIndex: 'transactionFlag',
      key: 'transactionFlag',
      render: (transactionFlag) => {
        const color = GetColor(transactionFlag)
        const status = GetStatus(transactionFlag)
        return (
          <span>
            <Tag color={color} key={transactionFlag}>
              {status}
            </Tag>
          </span>
        )
      }
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount'
    },
    {
      title: 'Date',
      dataIndex: 'transactionDate',
      key: 'transactionDate',
      render: (transactionDate) => {
        const Date = GetDate(transactionDate)
        return (
          <span>
            {Date}
          </span>
        )
      }
    },
    {
      title: 'Made by',
      dataIndex: 'transactionAction',
      key: 'transactionAction',
      render: (name, record) => {
        return <div>{CoinType[name] ? CoinType[name].title : name}</div>
      }
    }
  ]

  const GetColor = (transactionFlag) => {
    let color = ''
    if (transactionFlag !== null) {
      switch (transactionFlag) {
        case 1:
          color = 'green'
          break
        case 0:
          color = 'red'
          break
        default:
          break
      }
    }
    return color
  }
  const GetStatus = (transactionFlag) => {
    let status = ''
    if (transactionFlag !== null) {
      switch (transactionFlag) {
        case 1:
          status = 'debit'
          break
        case 0:
          status = 'credit'
          break
        default:
          break
      }
    }
    return status
  }

  const GetDate = (transactionDate) => {
    let date = ''
    if (transactionDate !== null) {
      date = moment(transactionDate).format('DD/MM/YYYY HH:mm:ss')
    }
    return date
  }

  return (
    <Card>
      <div align="right">
        <Tag color='#3700B3'>
          Current Coin :  {coin}
        </Tag>
        <span>
          <Button
            size="small"
            onClick={() => {
              onClick()
            }}
          >Update Coin</Button>
        </span>
      </div>
      <br></br>
      <h3>Transaction History</h3>
      <Table
        loading={isLoading}
        rowKey={(record) => record.id}
        dataSource={transaction}
        columns={columns}
      />
      <CoinForm
        visible={visible}
        heroId={heroId}
        coin={coin}
        onOk={onOk}
        onCancel={onCloseModal}
      />
    </Card>

  )
}

export default HeroCoin